import React from "react";
import "./MobileTabBar.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSidebarDisplay } from "../../Redux/SideDisplaySlice";
import { Home, Layers, Plus, Users, Menu } from "lucide-react";

// App-style bottom navigation, shown only on phones (≤ 800px — same
// breakpoint the sidebar collapses at). The centre "Deposit" tab is a raised
// gold action button; "Menu" opens the existing sidebar drawer.
const tabs = [
  { key: "home", label: "Home", Icon: Home, to: "/dashboard", match: ["/", "/dashboard"] },
  { key: "packages", label: "Packages", Icon: Layers, to: "/package", match: ["/package"] },
  { key: "deposit", label: "Deposit", Icon: Plus, to: "/deposit", match: ["/deposit"], primary: true },
  { key: "team", label: "Team", Icon: Users, to: "/direct_team", match: ["/direct_team", "/my_team"] },
  { key: "menu", label: "Menu", Icon: Menu, action: "menu" },
];

const MobileTabBar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const handleTab = (tab) => {
    if (tab.action === "menu") {
      dispatch(setSidebarDisplay("block"));
      return;
    }
    navigate(tab.to);
  };

  return (
    <nav className="mtb" aria-label="Primary">
      {tabs.map((tab) => {
        const active = tab.match?.includes(pathname);
        const { Icon } = tab;
        return (
          <button
            key={tab.key}
            type="button"
            className={`mtb-tab ${tab.primary ? "mtb-primary" : ""} ${active ? "is-active" : ""}`}
            onClick={() => handleTab(tab)}
            aria-current={active ? "page" : undefined}
            aria-label={tab.label}
          >
            <span className="mtb-icon">
              <Icon size={tab.primary ? 24 : 21} strokeWidth={active || tab.primary ? 2.4 : 2} />
            </span>
            <span className="mtb-label">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default MobileTabBar;
